import { useCallback } from 'react'

import type { FC } from 'react'

import {
	Select,
	SelectContent,
	SelectItem,
	SelectSeparator,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select'

import type { OperatorAndValue } from '../TableFilters'

export interface GroupByOptions {
	label: string
	value: string
}

interface Props {
	value: OperatorAndValue | null
	options: GroupByOptions[]
	onChange: (filters: OperatorAndValue) => void
}

const GroupFilter: FC<Props> = ({ value, options, onChange }) => {
	const handleValueChange = useCallback(
		(selectedOption: string) => {
			if (selectedOption === '__none__') {
				onChange(null)
			} else {
				onChange({ $eq: selectedOption } as OperatorAndValue)
			}
		},
		[onChange]
	)

	return (
		<Select value={value?.$eq ?? ''} onValueChange={handleValueChange}>
			<SelectTrigger size="sm">
				<SelectValue placeholder="Group By" />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="__none__" key="group-by-option-none">
					None
				</SelectItem>
				<SelectSeparator />
				{options.map(option => (
					<SelectItem
						value={option.value}
						key={`group-by-option-${option.value}`}
					>
						{option.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	)
}

export default GroupFilter
